module.exports = __webpack_public_path__ + "static/media/15_nature.ce66722f.jpg";